import "./OrderCancelModal.css";
import Modal from "@mui/material/Modal";
import NegativeIconImgSrc from "../../assets/image/png/error.png";
import { CircularProgress, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { customSx } from "../../components/createSecondaryOrder/util";
import { customStyle } from "./ViewOrderUtils";
import CloseIcon from '@mui/icons-material/Close';
import { useEffect } from "react"; // 1. Import useEffect
import useShortcutKeys from "../../components/dms_common/ShortcutKeys";

interface OrderCancelModalProps {
  headerText: string;
  modalOpen: boolean;
  selectedRejectionReason: string;
  loading: boolean;
  rejectionReasons: string[];
  onClose: () => void;
  handleReasonChange: (param: string) => void;
  onButtonClick: () => void;
  inputActive?: boolean
  inputString?: string;
  handleReasonStringChange?: (param: string) => void;
}

const OrderCancelModal: React.FC<OrderCancelModalProps> = ({
  headerText = "",
  modalOpen = false,
  selectedRejectionReason = "",
  loading = false,
  rejectionReasons = [],
  onClose = () => { },
  handleReasonChange = () => { },
  onButtonClick = () => { },
  inputActive,
  inputString = "",
  handleReasonStringChange = () => { },
}) => {

  const isButtonDisabled =
    selectedRejectionReason?.length === 0 ||
    loading ||
    (inputActive && (inputString.trim().length === 0));

  // 2. Add useEffect to handle the 'Escape' key press
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    // Add event listener only when the modal is open
    if (modalOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }

    // Cleanup: remove event listener when the component unmounts or modal closes
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [modalOpen, onClose]); // Dependencies for the effect

    const { positiveCta } = useShortcutKeys();
  
  return (
    <Modal
      open={modalOpen}
      onClose={onClose} // 3. It's good practice to also pass onClose to the Modal component itself
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="cancel-order-modal-container">
        <button style={{
          position: "absolute",
          top: "12px",
          right: "12px",
          background: "none",
          border: "none",
        }}
          onClick={onClose}>
          <CloseIcon
            style={{
              color: "#707070",
            }}
          />
        </button>

        <img src={NegativeIconImgSrc} className="OrderCancelModal_img" />
        <p className="OrderCancelModal_header">{headerText}</p>
        <p className="">Please mention the reason:</p>

        <FormControl
          fullWidth
          size="small"
          className="custom_form_control"
          sx={{ ...customSx, width: "53%" }}
        >
          <InputLabel sx={customSx} id="order-type-label">
            Select Reason
          </InputLabel>
          <Select
            id="selectedRejectionReason"
            value={selectedRejectionReason}
            onChange={(e) => {
              handleReasonChange(e.target.value);
              handleReasonStringChange("");
            }}
            className="select_customer_textfield"
            size="small"
            fullWidth
            sx={customSx}
            label="Select Reason"
          >
            {rejectionReasons?.map((rejectionReason) => (
              <MenuItem
                key={rejectionReason}
                value={rejectionReason}
                sx={{
                  color: "#464646",
                  fontSize: "14px",
                }}
              >
                {rejectionReason}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {inputActive &&
          <div className="CustomGenericModal_transporterGstin" style={{ width: "53%", marginTop: "10px" }}>
            <TextField
              label="Write rejection reason"
              size="small"
              type="text"
              id="rejectionReason"
              value={inputString}
              onChange={(e) => {
                const value = e.target.value;
                // Allow only alphanumeric characters
                if (/^[a-zA-Z0-9 ]*$/.test(value)) {
                  handleReasonStringChange(value)
                }
              }}
              className="select_customer_textfield"
              sx={customSx}
              inputProps={{
                maxLength: 100,
              }}
            />
          </div>}

        <button
          className="OrderCancelModal_button"
          disabled={isButtonDisabled}
          style={{
            background: isButtonDisabled ? "#EBEBEB" : "#00C6B1",
            color: isButtonDisabled ? "#7C7C7C" : "#FFFFFF",
            cursor: isButtonDisabled ? "not-allowed" : "pointer",
          }}
          onClick={onButtonClick}
        >
          {loading ? <CircularProgress style={customStyle} /> : "Continue"}
          &nbsp;<span style={{fontSize:"11px"}}>{positiveCta}</span>
        </button>

      </div>
    </Modal>
  );
};

export default OrderCancelModal;